/*
 * Constant list of all the tiles index, to easily use them in ordder to create the layout
 * See the template file for a clear example of how the tiles are placed
 */
export const tilesize = 32;
export const tilesets = [
    'assets/1_Industrial_Tileset_1B.png', // Tilesheet for the layout
    'assets/IndustrialTileset_Assets_free_v1.3_transparent_collectables_1_32p.png', // Tilesheet for the assets
    'assets/tiles.png', // Test tiles from LittleJS
    'assets/1_Industrial_Tileset_1.png', // Background tileset
    'assets/Chip_walking.png', // Chip walking spritesheet
    'assets/Chip_jumping.png', // Chip jumping spritesheet
    'assets/Rex.png', // Rex idle spritesheet
    'assets/Rex_walking.png', // Rex walking spritesheet
    'assets/Rex_jumping.png', // Rex jumping spritesheet
];
export const tilesheets = {
    LAYOUT: 0,
    ASSETS: 1,
    TEST: 2,
    BACKGROUND: 3,
    CHIP_WALKING: 4,
    CHIP_JUMPING: 5,
    REX_IDLE: 6,
    REX_WALKING: 7,
    REX_JUMPING: 8
};
export const tiles = {
    /* Platforms */
    PLATFORM_LEFT_TIP: 0,
    PLATFORM_MIDDLE: 1,
    PLATFORM_RIGHT_TIP: 2,
    FLOATING_BLOCK: 3,
    /* Walls with one corner / spot touching the outside */
    WALL_BOTTOM_RIGHT_CORNER: 4,
    WALL_BOTTOM_LEFT_CORNER: 5,
};
